/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリスト名を更新した時の操作ログとして記録する内容
 * @export
 * @interface UpdatedMediaListNameOperationLog
 */
export interface UpdatedMediaListNameOperationLog {
    /**
     * メディアリストに対する操作の種類
     * @type {string}
     * @memberof UpdatedMediaListNameOperationLog
     */
    actionType: string;
    /**
     * 変更前のメディアリスト名
     * @type {string}
     * @memberof UpdatedMediaListNameOperationLog
     */
    originalMediaListName: string;
    /**
     * 変更後のメディアリスト名
     * @type {string}
     * @memberof UpdatedMediaListNameOperationLog
     */
    updatedMediaListName: string;
}

export function UpdatedMediaListNameOperationLogFromJSON(json: any): UpdatedMediaListNameOperationLog {
    return UpdatedMediaListNameOperationLogFromJSONTyped(json, false);
}

export function UpdatedMediaListNameOperationLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedMediaListNameOperationLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'originalMediaListName': json['original_media_list_name'],
        'updatedMediaListName': json['updated_media_list_name'],
    };
}

export function UpdatedMediaListNameOperationLogToJSON(value?: UpdatedMediaListNameOperationLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.actionType,
        'original_media_list_name': value.originalMediaListName,
        'updated_media_list_name': value.updatedMediaListName,
    };
}

